import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { MaintenanceService } from '../services/maintenance.service';

/**
 * Guard to check if maintenance mode is active
 * If maintenance is active, redirects to maintenance page
 * If maintenance is not active, allows navigation
 */
export const maintenanceGuard: CanActivateFn = async (
    route,
    state
): Promise<boolean | UrlTree> => {
    const maintenanceService = inject(MaintenanceService);
    const router = inject(Router);

    const isMaintenanceActive = await maintenanceService.isMaintenanceActive();

    if (isMaintenanceActive) {
        // Redirect to maintenance page
        return router.createUrlTree(['/maintenance']);
    }

    // Allow navigation
    return true;
};
